module.exports = __webpack_public_path__ + "img/tank-horizontal-selected.d0815a19.svg";